import gql from 'graphql-tag';

const MarketActivityFragment = gql`
    fragment MarketActivity on MarketActivityStats {
        data {
            averagePricePaid
            propertiesSold
        }
        error {
            message
            code
            path
        }
    }
`;

export default MarketActivityFragment;
